import type { LedgerEvent } from "../lib/api";
import { ownerInputs } from "./RecentChoices";

export interface RecentReply {
  id: string; title: string; sessionId: string; at: number;
}
export interface OverviewReply extends RecentReply {
  agentId: string; agentName: string; href: string;
}

/** Replies to this Owner's original requests, from the existing work projection, never artifact acceptance. */
export function recentReplies(events: LedgerEvent[], owner: string): RecentReply[] {
  if (!owner) return [];
  const endings = new Map(events.filter(event => event.kind === "l0.turn_final").map(event => [event.row.turn_id, event.row]));
  return ownerInputs(events).flatMap(event => {
    const row = event.row;
    if (row.principal_id !== owner || row.no_reply || row.stop || row.action_state !== "completed" || row.has_reply !== true) return [];
    const ending = endings.get(row.latest_turn_id);
    const result = ending?.result as Record<string, unknown> | undefined;
    if (!ending || result?.status !== "done" || ending.session_id !== row.session_id
      || typeof row.obligation_id !== "string" || typeof row.session_id !== "string"
      || typeof row.text !== "string" || !row.text.trim()) return [];
    const at = typeof result.finished_at === "number" ? result.finished_at : Date.parse(String(result.finished_at)) / 1000;
    if (!Number.isFinite(at)) return [];
    return [{ id: row.obligation_id, title: row.text, sessionId: row.session_id, at }];
  }).sort((left, right) => right.at - left.at);
}
